import React, { FC } from 'react';
import Badge from '@material-ui/core/Badge';
import styled from 'styled-components';
import { useDataTableFilterContext } from '../../../utils/DataTableFilterContext';
import { useIntlUds } from '../../../../../translations/UdsIntlProvider';
import { PermanentFilterButton } from '../view/PermanentFilterButton';

export const AllFiltersButton: FC<React.PropsWithChildren<unknown>> = () => {
  const { intl } = useIntlUds();
  const { setOpenFilterDrawer, hasFilters, hiddenVariables, activeFilters, clearFilterAll } =
    useDataTableFilterContext();

  if (!hasFilters) return null;

  const hasSelectedFilters = hiddenVariables?.length
    ? activeFilters?.filter((filter) => !hiddenVariables.includes(filter.id)).length > 0
    : activeFilters.length > 0;

  const activeFiltersLength = activeFilters.length ?? 0;

  return (
    <StyledBadge badgeContent={activeFiltersLength} color="primary">
      <PermanentFilterButton
        label={intl.DataTable.Filters.allFiltersLabel}
        dataTest="data-table-all-filter-button"
        active={hasSelectedFilters}
        onClick={() => setOpenFilterDrawer(true)}
        onDelete={() => clearFilterAll()}
      />
    </StyledBadge>
  );
};

const StyledBadge = styled(Badge)`
  .MuiBadge-anchorOriginTopRightRectangle {
    transform: scale(1) translate(42%, -37%);
    pointer-events: none;
  }
`;
